import { JsonSchemaActionPropertiesFormProperties } from "./audit-event.model";

export class AuditActionForm{
  name: string;
  valid: boolean;
  schema: JsonSchemaActionPropertiesFormProperties
}



// WEBPACK FOOTER //
// ./src/app/views/audit/models/audit-action.model.ts